import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const VideoElement = styled.video`
  object-fit: cover;
  border-radius: 12px;
  height: 100%;
  width: 100%;
  opacity: ${(props) => (props.$loaded ? "1" : "0")};
  transition: opacity 0.3s ease;
`;

export const ModalContainer = styled.div`
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  border: 1px solid #18181b;
  background: #0a0b0c;
  width: 100%;
  max-width: 340px;
  height: 420px;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  @media (max-width: 470px) {
    max-width: 360px;
  }
`;

export const ModalContent = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: DM Sans;

  font-size: 15px;

  font-weight: 400;
  line-height: 20px; /* 133.333% */
  opacity: 0.5;
`;

export const Row = styled.div`
  display: flex;

  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
`;

export const NoticeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const NoticeText = styled.span`
  color: #fff;
  font-family: DM Sans;

  font-size: 15px;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  opacity: ${(props) => (props.$light ? 0.4 : 1)};
`;
export const NoticeItem = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 8px 0 0 0;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.8)"};
  text-align: center;
`;

export const LinkText = styled.span`
  color: #2877d9;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;

  &:hover {
    color: #38f9d7;
  }
`;

export const ContinueButton = styled.button`
  display: flex;
  padding: 8px 44px 8px 32px;
  justify-content: center;
  width: fit-content;
  align-items: center;
  align-self: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 100px;
  background: #fff;

  color: #09090b;
  font-family: DM Sans;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  transition: all 0.3s ease;
  margin-top: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ModalText = styled.span`
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.8)"};
`;

export const Button = styled.button`
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;

  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.07px;

  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: row;

  &:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.7);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StyledButton2 = styled.button`
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  outline: none;
  cursor: pointer;

  z-index: 3;
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;

  transition: all 0.3s ease;
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: row;
  &:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.7);
    transform: translateY(-1px);
  }
`;

export const FavoriteButton = styled(StyledButton2)`
  position: absolute;

  left: 17px;
  bottom: 65px;
`;

export const MessageButton = styled(StyledButton2)`
  position: absolute;

  left: 17px;
  bottom: 115px;
`;

export const Tooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  font-size: 14px;
  font-family: DM Sans;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1000;

  /* Arrow */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.9);
  }

  /* Animation */
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`;
export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 5;
`;
export const VideoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  height: 100%;
`;

export const ThumbnailVideo = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "0" : "1")};
  visibility: ${(props) => (props.$loaded ? "hidden" : "visible")};
  filter: ${(props) => (props.$blur ? "blur(8px)" : "none")};
  transform: ${(props) => (props.$blur ? "scale(1.1)" : "scale(1)")};
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;
`;
export const LoadingSpinnerVideo = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const VideoFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  /* pointer-events: none; */
  color: white;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 61.05%,
    rgba(0, 0, 0, 0.64) 100%
  );
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  z-index: 2;

  justify-content: flex-end;
  gap: 12px;
  transition: all 0.3s ease-in-out;
  padding: 16px;
`;

export const ModelName = styled.div`
  color: #fff;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  position: absolute;
  left: 16px;
  top: 12px;
`;

export const ModelSeed = styled.div`
  color: #fff;
  font-family: DM Sans;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.07px;

  display: flex;
  padding: 3px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: rgba(24, 24, 27, 0.18);
  position: absolute;
  left: 16px;
  top: 40px;
  z-index: 3;
`;

export const Date = styled.div`
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  white-space: nowrap;
  opacity: 0.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
